import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  main: {
    '& p:last-child': {
      fontWeight: 600,
    },
  },
});
